import { array, partial } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import {
	WholeHouseFoundationId,
	WholeHouseFoundationBasementId,
	WholeHouseFramingId,
	WholeHouseDecksAndPorchesId,
	WholeHouseEwpFloorRoofLayoutId,
	WholeHouseDimensionalFloorRoofLayoutId,
	WholeHouseExteriorFinishesId,
	WholeHouseInteriorFinishesId,
	WholeHouseOpeningsId,
	WholeHouseRoofingId,
	WholeHouseFlatRoofingId,
} from './Id';

export const StructuredIds = partial({
	wholeHouseFoundation: array(WholeHouseFoundationId),
	wholeHouseFoundationBasement: array(WholeHouseFoundationBasementId),
	wholeHouseFraming: array(WholeHouseFramingId),
	wholeHouseDecksAndPorches: array(WholeHouseDecksAndPorchesId),
	wholeHouseEwpFloorRoofLayout: array(WholeHouseEwpFloorRoofLayoutId),
	wholeHouseDimensionalFloorRoofLayout: array(WholeHouseDimensionalFloorRoofLayoutId),
	wholeHouseExteriorFinishes: array(WholeHouseExteriorFinishesId),
	wholeHouseInteriorFinishes: array(WholeHouseInteriorFinishesId),
	wholeHouseOpenings: array(WholeHouseOpeningsId),
	wholeHouseRoofing: array(WholeHouseRoofingId),
	wholeHouseFlatRoofing: array(WholeHouseFlatRoofingId),

	wholeHouseBlockWork: iotsUtils.neverDecoder,
	wholeHouseIntFraming: iotsUtils.neverDecoder,
	wholeHouseExtFraming: iotsUtils.neverDecoder,
	wholeHouseFramingMaterial: iotsUtils.neverDecoder,
	wholeHouseFlooring: iotsUtils.neverDecoder,
	wholeHouseWindows: iotsUtils.neverDecoder,
	wholeHouseDoors: iotsUtils.neverDecoder,
	wholeHouseCeilings: iotsUtils.neverDecoder,
	wholeHouseInsulation: iotsUtils.neverDecoder,
	wholeHouseEavesSoffits: iotsUtils.neverDecoder,
	wholeHouseGutters: iotsUtils.neverDecoder,
	wholeHouseDrywall: iotsUtils.neverDecoder,
	wholeHouseMillwork: iotsUtils.neverDecoder,
	wholeHouseIntWallCladding: iotsUtils.neverDecoder,
	wholeHouseExtWallCladding: iotsUtils.neverDecoder,
	wholeHouseIntFixtures: iotsUtils.neverDecoder,
	wholeHouseFireRatedSystems: iotsUtils.neverDecoder,
	wholeHouseHardware: iotsUtils.neverDecoder,
});
